import React, { useEffect } from 'react';
import { Route, Redirect, Switch, useLocation } from 'react-router-dom';
import { ModalSwitch } from '@erecruit/core';
import { AppPermissions } from '@erecruit/types';
import { Page404, usePermissions, AuthorizedRoute } from '@erecruit/modules';

import Wizard from '../../components/AddNewPositionWizard';
import { NotificationPage } from '../../components/Notifications';
import { Dashboard } from '../../pages/Dashboard';
import Matches from '../../pages/Matches';
import PositionRecord from '../../components/PositionRecord';
import { MatchRecord } from '../../components/MatchRecord';
import Positions from '../../pages/Positions';
import RequestPosition from '../../components/RequestPosition';
import Shifts from '../../pages/Shifts';
import { ShiftRecord } from '../../components/ShiftRecord';
import { Settings } from '../../components/Settings';
import { ShiftPositionSearch } from '../../components/AddNewShiftWizard';
import { AddNewShiftWizard } from '../../components/AddNewShiftWizard';
import TimeSheets from '../../pages/Timesheets';
import Reports from '../../pages/Reports';
import BroadcastMessages from '../../components/BroadcastMessages/BroadcastMessages';
import BroadcastMessagePage from '../../components/BroadcastMessages/BroadcastMessagePage';
import { ProblemReportModal } from '../../components/ProblemReport';

const ModalElement = (
  <Switch>
    <AuthorizedRoute
      permission={AppPermissions.AddNewPosition}
      path="/wizard"
      component={Wizard}
    />
    <AuthorizedRoute
      permission={AppPermissions.AddNewPosition}
      path="/requestPosition"
      component={RequestPosition}
    />
    <AuthorizedRoute
      permission={`${AppPermissions.AddNewShift} & ${AppPermissions.ViewPositions}`}
      path="/addNewShift"
      component={ShiftPositionSearch}
    />
    <AuthorizedRoute
      permission={`${AppPermissions.AddNewShift} & ${AppPermissions.ViewPositions}`}
      path="/addNewShiftWizard"
      component={AddNewShiftWizard}
    />
    <Route path="/notifications" component={NotificationPage} />
    <Route path="/broadcastmessage/:id" component={BroadcastMessagePage} />
    <AuthorizedRoute
      permission={AppPermissions.ReportProblem}
      path="/problemreport"
      component={ProblemReportModal}
    />
  </Switch>
);

const Content = () => {
  const { refreshPermissions } = usePermissions();
  const location = useLocation();

  useEffect(() => {
    refreshPermissions();
  }, [location.pathname, refreshPermissions]);

  return (
    <>
      <BroadcastMessages />
      <ModalSwitch modal={ModalElement} noMatchComponent={Page404}>
        <Route path="/dashboard" component={Dashboard} />
        <AuthorizedRoute
          permission={AppPermissions.ViewMatches}
          path="/matches"
          component={Matches}
        />
        <AuthorizedRoute
          permission={`${AppPermissions.ViewMatches} & ${AppPermissions.ViewMatch}`}
          path="/match/:id"
          component={MatchRecord}
        />
        <AuthorizedRoute
          permission={AppPermissions.ViewPositions}
          path="/positions"
          component={Positions}
        />
        <AuthorizedRoute
          permission={`${AppPermissions.ViewPositions} & ${AppPermissions.ViewPosition}`}
          path="/position/:id/:matchStatus?"
          component={PositionRecord}
        />
        <AuthorizedRoute
          permission={AppPermissions.ViewShifts}
          path="/shifts"
          component={Shifts}
        />
        <AuthorizedRoute
          permission={`${AppPermissions.ViewShifts} & ${AppPermissions.ViewShift}`}
          path="/shift/:id"
          component={ShiftRecord}
        />
        <AuthorizedRoute
          permission={AppPermissions.Timesheets}
          path="/timesheets"
          component={TimeSheets}
        />
        <AuthorizedRoute
          permission={AppPermissions.Reports}
          path="/reports"
          component={Reports}
        />
        <Route path="/settings" component={Settings} />
        <Redirect from="/" to="/dashboard" exact />
      </ModalSwitch>
    </>
  );
};

export default Content;
